import RelativeDiagnosis from "./RelativeDiagnosis";

export default class Relative {
	constructor(diagnosisType) {
		this.relativeName = null;
		this.relativeTypeId = null;
		this.relativeDiagnosisType = diagnosisType;

		this.relativeDiagnoses = [new RelativeDiagnosis()];
	}
}
